$.fn.featuredImages = function() {
  let self = this

  self.find('.picture').each(function() {
    var keys = Object.keys(featured_images);
    var random = keys.length * Math.random() << 0
    $(this).html('<img src="' + featured_images[keys[random]] + '"/>')
    delete featured_images[keys[random]]
    $(this).addClass('--loaded')
  })

  return function() {
    return self
  }()
}
